
import scrollSmooth from './helpers/smooth-scroll.js';
import ticket from './modules/ticket.js';
import expozone from './modules/expozone.js';
import afterparty from "./modules/afterparty";
import burgerMenu from "./modules/burger-menu";
import charity from "./modules/charity";


expozone()
afterparty()
scrollSmooth();
burgerMenu();


function paralax () {
  let items = document.querySelectorAll('.parallax')
  let coef = 0.09

  document.addEventListener('scroll', function () {

    for(let i = 0; i < items.length; i++) {
      let coord = items[i].parentElement.getBoundingClientRect().top * coef
      items[i].style.transform = `translateY(${coord}px)`
    }
  })
}
paralax ()

function main() {
  ticket()
  // charity()
}


if (document.documentElement.clientWidth < 480) {
  window.addEventListener('scroll',
    function () {
      return setTimeout(main, 1000);
    }, {
      once: true
    });
} else {
  main();
};
